import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { MessageCircle } from "lucide-react";

export function MessageAdminButton() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [adminId, setAdminId] = useState(null);

  useEffect(() => {
    api.get("/support/admin").then(({ data }) => setAdminId(data.id)).catch(() => {});
  }, []);

  if (user && adminId && user.id === adminId) return null;

  const handleClick = () => {
    if (!user) return navigate("/login");
    if (adminId) navigate(`/messages/${adminId}`);
  };

  return (
    <button
      data-testid="message-admin-fab"
      onClick={handleClick}
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 pl-4 pr-5 py-3 rounded-full shadow-xl font-semibold text-white transition-transform hover:-translate-y-0.5"
      style={{ background: "var(--brand)" }}
      title="Message the admin"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline">Message Admin</span>
    </button>
  );
}
